  import React, {Component, Fragment} from 'react';
  import {withTranslation} from 'react-i18next';
  import {
  Form,
  TextfieldElement,
  FormFooter,
  TextareaElement, Button,CheckboxesElement,
  FormSubmit, SubHeading, FormHeader, FormMandatoryPrompt
  } from "cw-styleguide-react";
  import withAssets from "../../../components/hoc/withAssets";
  import i18n from "../../../i18n";
  import {ACTION_SAVE, LANGUAGE_EN, STATUS_DRAFT} from "../../../constants";
  import moment from "moment";


  class VenueCreateEditForm extends Component {

    /**
     * render
     * @returns {JSX.Element}
     */
    render() {

      return (
        <Fragment>

          {this.props.values.status && <p><strong>{this.props.t('local:view.venues.edit.field.currentStatus.label')}</strong> { this.props.courses.getStatusName(this.props.values.status)}</p>}

          {this.props.audit && this.props.audit.createdBy &&
            <p><strong>{this.props.t('local:view.venues.edit.field.createdBy.label')}</strong>: {this.props.audit.createdBy.name} {moment(this.props.audit.dateCreated).format("DD/MM/YYYY HH:mm:ss")}</p>
          }

          {this.props.audit && this.props.audit.updatedBy &&
            <p><strong>{this.props.t('local:view.venues.edit.field.updatedBy.label')}</strong>: {this.props.audit.updatedBy.name} {moment(this.props.audit.dateUpdated).format("DD/MM/YYYY HH:mm:ss")}</p>
          }


          <SubHeading type={"sub-heading-small"} colour={"sub-heading-small--b"} >{this.props.inputLanguage === LANGUAGE_EN ? i18n.t('styleguide:languages.englishVersion') : i18n.t('styleguide:languages.welshVersion') }</SubHeading>
          <Form>

            <FormHeader title={this.props.t('local:view.venues.' + this.props.mode + '.formTitle')}
                        introduction={this.props.t('local:view.venues.' + this.props.mode + '.formDescription')}>
              <FormMandatoryPrompt/>
            </FormHeader>

            {/* Venue name */}
            <TextfieldElement size={'medium'} label={this.props.t('local:view.venues.create.field.venueName.label')}
                              id={'venueName_' + this.props.inputLanguage}
                              description={this.props.t('local:view.venues.create.field.venueName.description')}
                              required={true}
                              name={'venueName_' + this.props.inputLanguage }
                              value={this.props.values['venueName_' + this.props.inputLanguage] }
                              onChange={this.props.handleChange}
                              errors={this.props.formErrors['venueName_' + this.props.inputLanguage]}
                              onKeyPress={this.context.preventDefaultOnEnter}/>

            {/* Postcode (Non Translatable) */}
            <TextfieldElement size={'medium'}
                              label={this.props.t('local:view.venues.create.field.postcode.label')}
                              description={this.props.t('local:view.venues.create.field.postcode.description')}
                              advancedDescription={{
                                link: {
                                  text: this.props.t('local:view.venues.create.field.postcode.advancedDescription.link.text'),
                                  title: this.props.t('local:view.venues.create.field.postcode.advancedDescription.link.title'),
                                },
                                body: this.props.t('local:view.venues.create.field.postcode.advancedDescription.body')
                              }}
                              id={'postCode'}
                              name={'postCode'}
                              required={true}
                              placeholder={this.props.t('local:view.venues.create.field.postcode.placeholder')}
                              value={this.props.values['postCode'] }
                              onChange={this.props.handleChange}

                              onKeyPress={this.context.preventDefaultOnEnter}
                              group_classes={["form__autocomplete-search"]}
                              hasButton={true}
                              errors={this.props.formErrors.postCode}
                              suffix={
                                <Fragment>
                                  <Button classes={['button','button--suffix','button--style-blue']} onClick={this.props.handleFindAddress}>{this.props.t('local:view.venues.create.field.postcode.findAddress')}</Button>
                                  {!this.props.hasManualAddress() && <span> {this.props.t('styleguide:or')} <Button onClick={this.props.handleManualAddress} asLink={true}>{this.props.t('local:view.venues.create.field.postcode.manualAddress')}</Button></span>}
                                </Fragment>}
                              groupElement={
                                <Fragment>
                                  {this.props.showAddressSuggestions && <div className={"group__autocomplete-results " }>
                                    <ul>

                                      {this.props.addresses.map((option, i) => {
                                        return (
                                          <li  key={i}>
                                            <a onMouseDown={this.props.handleSelectAddress} data-addressline1={option.addressLine1 } data-addressline2={option.addressLine2} data-addressline3={option.addressLine3 } data-addressline4={option.addressLine4} data-county={option.county } data-towncity={option.townCity}  data-postcode={option.postcode} >{ [option.addressLine1, option.addressLine3, option.county, option.townCity, option.postcode].join(', ') } </a>
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </div>}
                                </Fragment>
                              }
            />

            {/* Address 1 */}
            {(this.props.hasManualAddress() ||
              this.props.manualAddress ||
              this.props.formErrors['addressLine1_' + this.props.inputLanguage] ||
              this.props.formErrors['townCity_' + this.props.inputLanguage] ||
              this.props.formErrors['county_' + this.props.inputLanguage]
            ) && <Fragment>


              <TextfieldElement size={'medium'} label={this.props.t('local:view.venues.create.field.addressLine1.label')}
                                id={'addressLine1_' + this.props.inputLanguage}
                                name={'addressLine1_' + this.props.inputLanguage }
                                required={true}
                                value={this.props.values['addressLine1_' + this.props.inputLanguage] }
                                onChange={this.props.handleChange}
                                errors={this.props.formErrors['addressLine1_' + this.props.inputLanguage]}
                                onKeyPress={this.context.preventDefaultOnEnter}/>

              <TextfieldElement size={'medium'} label={this.props.t('local:view.venues.create.field.addressLine2.label')}
                                id={'addressLine2_' + this.props.inputLanguage}
                                name={'addressLine2_' + this.props.inputLanguage }
                                value={this.props.values['addressLine2_' + this.props.inputLanguage] }
                                onChange={this.props.handleChange}
                                onKeyPress={this.context.preventDefaultOnEnter}/>

              <TextfieldElement size={'medium'} label={this.props.t('local:view.venues.create.field.addressLine3.label')}
                                id={'addressLine3_' + this.props.inputLanguage}
                                name={'addressLine3_' + this.props.inputLanguage }
                                value={this.props.values['addressLine3_' + this.props.inputLanguage] }
                                onChange={this.props.handleChange}
                                onKeyPress={this.context.preventDefaultOnEnter}/>
              <TextfieldElement size={'medium'} label={this.props.t('local:view.venues.create.field.addressLine4.label')}
                                id={'addressLine4_' + this.props.inputLanguage}
                                name={'addressLine4_' + this.props.inputLanguage }
                                value={this.props.values['addressLine4_' + this.props.inputLanguage] }
                                onChange={this.props.handleChange}
                                onKeyPress={this.context.preventDefaultOnEnter}/>
              <TextfieldElement size={'medium'} label={this.props.t('local:view.venues.create.field.townCity.label')}
                                id={'townCity_' + this.props.inputLanguage}
                                name={'townCity_' + this.props.inputLanguage }
                                required={true}
                                value={this.props.values['townCity_' + this.props.inputLanguage] }
                                onChange={this.props.handleChange}
                                errors={this.props.formErrors['townCity_' + this.props.inputLanguage]}
                                onKeyPress={this.context.preventDefaultOnEnter}/>

              <TextfieldElement size={'medium'} label={this.props.t('local:view.venues.create.field.county.label')}
                                id={'county_' + this.props.inputLanguage}
                                name={'county_' + this.props.inputLanguage }
                                required={true}
                                value={this.props.values['county_' + this.props.inputLanguage] }
                                onChange={this.props.handleChange}
                                errors={this.props.formErrors['county_' + this.props.inputLanguage]}
                                onKeyPress={this.context.preventDefaultOnEnter}/>
            </Fragment>}









            {/* Facilities (Non Translatable) */}
            <CheckboxesElement name={'facilitiesAvailable'} id={'facilitiesAvailable'}
                               label={this.props.t('local:view.venues.create.field.facilitiesAvailable.label')}
                               description={this.props.t('local:view.venues.create.field.facilitiesAvailable.description')}
                               value={this.props.values['facilitiesAvailable'] }
                               onChange={this.props.handleChange}
                               options={this.props.courses.assets.venues.facilitiesAvailable}/>


            {/* Extra Facilities */}
            <TextareaElement
              name={'extraFacilities_' + this.props.inputLanguage}
              id={'extraFacilities_' + this.props.inputLanguage}
              description={this.props.t('local:view.venues.create.field.extraFacilities.description')}
              value={this.props.values['extraFacilities_' + this.props.inputLanguage] }
              label={this.props.t('local:view.venues.create.field.extraFacilities.label')}
              errors={this.props.formErrors['extraFacilities_' + this.props.inputLanguage]}
              onChange={this.props.handleChange}
            />


            {this.props.values['learnerSupport'].has("267040006")}
            {/* Learner support (Non Translatable) */}
            <CheckboxesElement name="learnerSupport" id="learnerSupport"
                               label={this.props.t('local:view.venues.create.field.learnerSupport.label')}
                               description={this.props.t('local:view.venues.create.field.learnerSupport.description')}
                               value={this.props.values['learnerSupport'] }
                               onChange={this.props.handleChange}
                               options={this.props.courses.assets.venues.learnerSupport}/>
            <FormFooter>
              <FormSubmit title={'Submit'} value={'Submit'} icon={{type: 'chevron-right', position: 'right'}}
                          onClick={(event) => {event.preventDefault(); this.props.saveVenue(this.props.getSaveState(STATUS_DRAFT, ACTION_SAVE))}}>
                {this.props.t('styleguide:forms.save')}
              </FormSubmit>
            </FormFooter>
          </Form>

        </Fragment>

      );
    }

  }

  export default withAssets(withTranslation('local')(VenueCreateEditForm));
